import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { ITabelaPrecoDTO } from '../dto/tabela-preco-dto';
import { ITabelaPreco } from '../models/tabela-preco';
import { TabelasPrecoApi } from '../api/tabelas-preco.api';

@Injectable()
export class TabelasPrecoService extends ServiceBase<ITabelaPreco, ITabelaPrecoDTO> {

    constructor(private api: TabelasPrecoApi) {
        super(api);
    }
}
